import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  padding: 10px 0;
`
